<script lang="ts">
  import { _ } from 'svelte-i18n';
  import type { Team, Club } from '../types';
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let club: Club;
  export let teams: Team[];
  export let selectedTeam: Team;
  export let onLeaveTeam: (team: Team) => void = () => {};

  function handleTeamClick(team: Team) {
    if (team.user_role === 'ADMIN') {
      // ADMINs can edit the team
      selectedTeam = team;
    } else {
      // MEMBERs get a leave confirmation
      onLeaveTeam(team);
    }
  }

  // @ts-ignore - Vite-specific type that TypeScript doesn't know about
  const BUILD_TIMESTAMP = import.meta.env.VITE_BUILD_TIMESTAMP || Date.now();


</script>

<article class="club-card">
  <header class="flex items-center gap-4">
      {#if club.logo_filename}
        <img 
          src={`/img/clublogos/${club.logo_filename}?v=${BUILD_TIMESTAMP}`} 
          alt="{club.name}" 
          class="club-logo"
        />
      {:else}
        <div class="club-logo-placeholder">
          <ion-icon name="shield-outline"></ion-icon>
        </div>
      {/if}
      <h4>{club.name}</h4>
  </header>

  <div class="teams-list">
    {#each teams as team}
        <button 
            class="primary full-width align-left mb-2 flex justify-between" 
            on:click={() => handleTeamClick(team)}
        >
            <span>{team.name}</span>
            {#if team.user_role === 'ADMIN'}
              <ion-icon name="chevron-forward-outline"></ion-icon>
            {:else}
              <ion-icon name="trash-outline"></ion-icon>
            {/if}
        </button>
    
    {/each}
  </div>
</article>

<style>
  .club-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s;
  }

  .club-card:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  .club-logo {
    width: 56px;
    height: 56px;
    border-radius: 8px;
    object-fit: contain;
  }

  .club-logo-placeholder {
    width: 56px;
    height: 56px;
    border-radius: 8px;
    background-color: var(--color-background-tertiary, #f3f4f6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-secondary, #666);
  }

  .club-logo-placeholder ion-icon {
    font-size: 28px;
  }


  .teams-list {
    padding: 0;
  }


</style>
